import useSWR from 'swr';
import {
  ExperienceVersion,
  GetListingV3PublicEndpoint,
  LanguageCode,
} from '@kouto/types';
import getListingV3 from 'api/listing/useListingV3/getListingV3';
import { PublicListingDetailsV3 } from 'types/listingV3';

type UseListingV3Props = {
  listingId?: string | null;
  skip?: boolean;
  language?: LanguageCode;
  version?: ExperienceVersion;
};

const useListingV3 = ({
  listingId,
  skip,
  language,
  version,
}: UseListingV3Props) => {
  const url =
    skip || !listingId
      ? null
      : GetListingV3PublicEndpoint.url({
          listingId,
          query: {
            language,
            version,
          },
        });

  const swr = useSWR<PublicListingDetailsV3>(url, getListingV3, {
    onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
      if (retryCount >= 3) return;
      if (error.status < 500) return;
      setTimeout(() => revalidate({ retryCount }), 2 ** retryCount * 1000);
    },
  });
  return swr;
};

export default useListingV3;
